import { Car, Users, Zap, Plane, Briefcase, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { useLang } from "@/i18n";

const IMG_MINIVAN =
  "https://images.pexels.com/photos/36377055/pexels-photo-36377055.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const IMG_ELECTRIC =
  "https://images.unsplash.com/photo-1700411881984-971bc29083bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxibGFjayUyMHRlc2xhJTIwbW9kZWwlMjAzfGVufDB8fHx8MTc5MDI0MzU5Mnww&ixlib=rb-4.1.0&q=85";
const IMG_AIRPORT =
  "https://images.unsplash.com/photo-1655827763440-7905302b75ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxhaXJwb3J0JTIwcGFzc2VuZ2VyJTIwbHV4dXJ5JTIwbHVnZ2FnZSUyMGNhcnxlbnwwfHx8fDE3OTAyNDE0NzN8MA&ixlib=rb-4.1.0&q=85";

const META = [
  { icon: Car, span: "lg:col-span-4", img: null },
  { icon: Users, span: "lg:col-span-4", img: IMG_MINIVAN },
  { icon: Zap, span: "lg:col-span-4", img: IMG_ELECTRIC },
  { icon: Plane, span: "lg:col-span-6", img: IMG_AIRPORT },
  { icon: Briefcase, span: "lg:col-span-6", img: null },
];

const Card = ({ s, meta, i }) => (
  <Reveal delay={i * 0.08} className={meta.span}>
    <div
      data-testid={`service-card-${i}`}
      className="group relative flex h-full min-h-[300px] flex-col justify-end overflow-hidden rounded-3xl border border-white/10 bg-[#0F0F14] p-8 transition-all duration-500 hover:border-amber-400/40"
    >
      {meta.img && (
        <>
          <img
            src={meta.img}
            alt={s.title}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-40 transition-all duration-700 group-hover:scale-105 group-hover:opacity-55"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0E] via-[#0A0A0E]/60 to-transparent" />
        </>
      )}
      <ArrowUpRight className="absolute right-6 top-6 h-6 w-6 text-amber-400 opacity-0 transition-all duration-500 group-hover:translate-x-1 group-hover:opacity-100" />
      <div className="relative">
        <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl border border-amber-400/30 bg-amber-400/10">
          <meta.icon className="h-6 w-6 text-amber-400" />
        </div>
        <span className="font-mono-alt text-[10px] uppercase tracking-[0.28em] text-amber-300">
          {s.badge}
        </span>
        <h3 className="mt-2 font-display text-2xl font-bold text-white">{s.title}</h3>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400">{s.desc}</p>
      </div>
    </div>
  </Reveal>
);

export const Services = () => {
  const { t } = useLang();
  const s = t.services;
  return (
    <section id="servizi" className="mx-auto max-w-7xl px-5 py-28 sm:px-8">
      <SectionHeading eyebrow={s.eyebrow} title={s.title} accent={s.accent} />
      <div
        data-testid="services-bento-grid"
        className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-12"
      >
        {s.items.map((item, i) => (
          <Card key={i} s={item} meta={META[i]} i={i} />
        ))}
      </div>
    </section>
  );
};
